import { IconNames } from '@blueprintjs/icons';
import { DetailLabel, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { BaseNotification, type NotificationBaseProps } from '@strata/react-notifications';
import { CountdownTimer } from '@strata/react-timers';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

import { AppRoutes } from 'services/routes';

export interface PendingIntakeNotificationProps extends NotificationBaseProps {
    linkingId: string;
    productName: string;
    timestamp: string;
    small: boolean;
    additionalData: {
        auctionEnd: string;
        healthPlan: string;
        canDecline: boolean;
    };
}

export const PendingIntakeNotification = ({
    linkingId,
    productName,
    timestamp,
    additionalData,
    onNotificationClick,
    onRemoveNotificationClick,
    status,
    small,
}: PendingIntakeNotificationProps) => {
    const navigate = useNavigate();
    return (
        <BaseNotification
            notificationTitle="Action Required"
            icon={IconNames.WARNING_SIGN}
            bodyText={`A referral for ${productName} is pending intake.`}
            timestamp={timestamp}
            onNotificationClick={() => {
                onNotificationClick();
                navigate(AppRoutes.wonReferralDetails(linkingId));
            }}
            onRemoveNotificationClick={onRemoveNotificationClick}
            type={BaseNotification.Types.WARNING}
            status={status}
            lapsed={dayjs().isAfter(additionalData.auctionEnd)}
            additionalData={
                <>
                    {additionalData?.canDecline && (
                        <div style={{ width: '25%' }}>
                            <DetailLabel label="Time Remaining" />
                            <CountdownTimer endTime={additionalData.auctionEnd} />
                        </div>
                    )}
                    {!small && (
                        <DetailLabelValuePair
                            label="Health Plan"
                            value={additionalData.healthPlan}
                        />
                    )}
                </>
            }
        />
    );
};
